import styled from 'styled-components';

export const SectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const SectionContent = styled.section<{ $variant: string }>`
  height: 100%;
  padding: 32px 48px 48px;
  background-color: ${({ $variant, theme }) =>
    $variant === 'details' ? theme.colors.background.light : theme.colors.background.dark};
`;
